function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useMemo } from "react";
import classnames from "classnames";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import CarouselGallary from "/components/core/carousel-gallary/carousel-gallary";
import { trackEvent } from "services/bigbrain-service";
import { PRICING_PAGE_PURCHASE_NOW_CLICKED, PRICING_PAGE_SEAT_BUCKET_CHANGED, PRICING_PAGE_PERIOD_CHANGED } from "constants/bigbrain-event-types";
import { storeNumberOfSeats } from "services/sales-enrichment/sales-enrichment-service";
import { TIERS } from "constants/pricing";
import { getPreviousTierNameByTier } from "services/pricing/plans-service";
import ProductPriceAndFeaturesCard from "./product-price-and-features-card/product-price-and-features-card";
import { UsersSelect } from "./users-select/users-select-component";
import { PeriodSelect } from "./period-select/period-select-component";
import PurchaseNowModal from "../components/purchase-now-modal/purchase-now-modal";
import { getMostPopularTierAndText } from "/services/pricing/pricing-page/most-popular-service";
import { StyledProductPriceAndFeaturesCards } from "./product-prices-and-features-cards-component.scss";
const SEATS_OPTIONS = {
    3: 3,
    5: 5,
    10: 10,
    15: 15,
    20: 20,
    25: 25,
    30: 30,
    40: 40,
    50: 50,
    100: 100,
    "200+": 200
};
const ProductPriceAndFeaturesCards = ({ productName, isTypeformDisabled, hideFreeTier, hideFreeForever, translateOrTranslateWithParam, isHomepagePricing, cookies, forcePricing, abTests, hasFreeTier, isApplyMaxDiffFeatures })=>{
    const { tiers, color, ctaHoverBackgroundColor, ctaHoverBorderColor, ctaHoverTextColor, hideProductIcon, primaryColor, secondaryColor, productId, showLearnMoreVideo, showFreeTierComingSoon } = productPricingConfig[productName];
    const { color: coreColor } = productPricingConfig.core;
    const [seats, setSeats] = useState(Object.values(SEATS_OPTIONS)[0]);
    const [period, setPeriod] = useState("yearly");
    const [purchaseNowModal, setPurchaseNowModal] = useState(false);
    const [purchaseModalTarget, setPurchaseModalTarget] = useState(null);
    const onPurchaseNowClicked = ({ tier, target })=>{
        trackEvent(PRICING_PAGE_PURCHASE_NOW_CLICKED, {
            kind: productName,
            info1: tier.name,
            info2: period,
            info3: seats,
            productKind: productName
        });
        setPurchaseNowModal(true);
        setPurchaseModalTarget(target);
    };
    const setSelectedSeats = useCallback((newSelectedSeats)=>{
        storeNumberOfSeats(newSelectedSeats);
        trackEvent(PRICING_PAGE_SEAT_BUCKET_CHANGED, {
            info1: newSelectedSeats,
            info2: seats,
            productKind: productName
        });
        setSeats(newSelectedSeats);
    }, [
        productName,
        seats
    ]);
    const setSelectedPeriod = useCallback((newSelectedPeriod)=>{
        trackEvent(PRICING_PAGE_PERIOD_CHANGED, {
            info1: newSelectedPeriod,
            info2: period,
            productKind: productName
        });
        setPeriod(newSelectedPeriod);
    }, [
        period,
        productName
    ]);
    const getTiers = useCallback(()=>{
        // hasFreeTier is cookie monday_has_free_tier based
        // hideFreeTier is a prop passed from the generator
        // free tier will be hidden if hasFreeTier is false OR if hasFreeTier AND hideFreeTier are true
        // TODO: extract to util function or custom hook
        if (!hasFreeTier || hideFreeTier) {
            return tiers.filter((tier)=>tier.name !== TIERS.FREE);
        }
        return tiers;
    }, [
        tiers,
        hideFreeTier,
        hasFreeTier
    ]);
    const getPreviousTierName = (tier)=>{
        return getPreviousTierNameByTier(tier, tiers);
    };
    const mostPopularTier = useMemo(()=>{
        if (!tiers) return;
        const modefiedTiers = tiers.map((tier)=>_object_spread_props(_object_spread({}, tier), {
                tier: tier.name
            }));
        const { tier: mostPopularTierName } = getMostPopularTierAndText(seats, modefiedTiers, null, abTests, cookies, forcePricing);
        return mostPopularTierName;
    }, [
        abTests,
        cookies,
        forcePricing,
        seats,
        tiers
    ]);
    return /*#__PURE__*/ _jsxs(StyledProductPriceAndFeaturesCards, {
        numberOfTiers: getTiers().length,
        className: classnames("container", {
            "is-homepage-pricing": isHomepagePricing
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "seats-and-period-selection",
                children: [
                    /*#__PURE__*/ _jsx(UsersSelect, {
                        usersCountArray: SEATS_OPTIONS,
                        updateSelectedUserCountCallback: setSelectedSeats,
                        productName: productName
                    }),
                    /*#__PURE__*/ _jsx(PeriodSelect, {
                        color: color,
                        isHomepagePricing: isHomepagePricing,
                        primaryColor: primaryColor,
                        period: period,
                        onPeriodChange: setSelectedPeriod
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tiers",
                children: getTiers().map((tier)=>{
                    return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCard, {
                        period: period,
                        hideProductIcon: hideProductIcon,
                        productName: productName,
                        tier: tier,
                        tiers: tiers,
                        previousTierName: getPreviousTierName(tier),
                        color: color,
                        ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                        ctaHoverBorderColor: ctaHoverBorderColor,
                        ctaHoverTextColor: ctaHoverTextColor,
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        seats: seats,
                        coreColor: coreColor,
                        isMostPopular: mostPopularTier === tier.name,
                        onPurchaseNowClicked: onPurchaseNowClicked,
                        hideFreeForever: hideFreeForever,
                        isHomepagePricing: isHomepagePricing,
                        productId: productId,
                        showLearnMoreVideo: showLearnMoreVideo,
                        showFreeTierComingSoon: showFreeTierComingSoon,
                        isApplyMaxDiffFeatures: isApplyMaxDiffFeatures
                    });
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tiers tiers-mobile",
                children: /*#__PURE__*/ _jsx(CarouselGallary, {
                    className: "carousel-item",
                    autoplay: false,
                    wrapAround: false,
                    edgeEasing: "easeBack",
                    slidesToShow: 1,
                    slideIndex: 1,
                    cellAlign: "center",
                    cellSpacing: 16,
                    width: "100vw",
                    slideWidth: 0.7,
                    renderCenterLeftControls: ()=>{},
                    renderCenterRightControls: ()=>{},
                    heightMode: "max",
                    children: getTiers().map((tier)=>{
                        return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCard, {
                            period: period,
                            isTypeformDisabled: isTypeformDisabled,
                            hideProductIcon: hideProductIcon,
                            productName: productName,
                            tier: tier,
                            color: color,
                            ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                            ctaHoverBorderColor: ctaHoverBorderColor,
                            ctaHoverTextColor: ctaHoverTextColor,
                            seats: seats,
                            coreColor: coreColor,
                            isMostPopular: mostPopularTier === tier.name,
                            onPurchaseNowClicked: onPurchaseNowClicked,
                            translateOrTranslateWithParam: translateOrTranslateWithParam
                        });
                    })
                })
            }),
            /*#__PURE__*/ _jsx(PurchaseNowModal, {
                isOpen: purchaseNowModal,
                signupButton: purchaseModalTarget
            })
        ]
    });
};
export default ProductPriceAndFeaturesCards;
